module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_null_0.b60fcd1b.png";